import { headerStyles } from "@insite/content-library/Widgets/MyLists/MyListsHeader";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(headerStyles, {
    container: {
        gap: 40,
        css: css`
            padding-bottom: 20px;
            margin-bottom: 30px;
        `,
    },
    leftTopGridItem: {
        width: [10, 10, 6, 6, 6],
    },
    leftBottomGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["0", null, "20px", null, null], properties: ["padding-bottom"] }],
                    mediaOptions.min,
                )}
        `,
    },
    rightBottomGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["0", null, "20px", null, null], properties: ["padding-bottom"] }],
                    mediaOptions.min,
                )}
        `,
    },
});
